import * as t from "io-ts";
import { UnreachableVariantError } from "../unreachable-variant-error";

export const AnswerAttachmentContentType = t.keyof({
    "image/jpg": null,
    "image/jpeg": null,
    "image/png": null,
    "application/pdf": null,
    "application/xml": null,
    "application/json": null,
});
export type AnswerAttachmentContentType = t.TypeOf<typeof AnswerAttachmentContentType>;

export function getFileType(contentType: AnswerAttachmentContentType): string {
    switch (contentType) {
        case "image/jpg": return ".jpg";
        case "image/jpeg": return ".jpg";
        case "image/png": return ".png";
        case "application/pdf": return ".pdf";
        case "application/xml": return ".xml";
        case "application/json": return ".json";
        default: throw new UnreachableVariantError(contentType);
    }
}